import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import Button from "../../Button";
import VehicleForm from "../VehicleForm";
import {withTranslation} from "react-i18next";

class VehicleAddModal extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      modalOpen: !this.props.children,
      creating: false,
    };

    this.form = React.createRef();

    this.toggleModal = this.toggleModal.bind(this);
    this.submit = this.submit.bind(this);
  }

  toggleModal() {
    if(!this.props.children){
      this.props.onModalClose();
    }else{
      this.setState({
        modalOpen: !this.state.modalOpen
      })
    }
  }

  submit(){
    this.form.current.onSubmit()
  }

  render() {
    const {creating} = this.state;

    return <React.Fragment>
      {this.props.children && React.cloneElement( this.props.children, { onClick: () => this.setState({modalOpen: true}) } )}
      {this.state.modalOpen && <Modal isOpen size="xl">
        <ModalHeader toggle={this.toggleModal}>{this.props.t('title')}</ModalHeader>
        <ModalBody>
          <VehicleForm
            dataInitial={this.props.dataInitial}
            onCreated={vehicle => this.props.onAdded(vehicle)}
            ref={this.form}
            submitButton={false}
            onSavingStart={() => this.setState({creating: true})}
            onSavingStop={() => this.setState({creating: false})}
          />
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" className="mb-0" onClick={this.toggleModal}>{this.props.t('common:btn.cancel')}</Button>
          <Button
            loading={creating}
            onClick={this.submit}
          >{this.props.t('common:btn.save')}</Button>
        </ModalFooter>
      </Modal>}
    </React.Fragment>
  }
}

VehicleAddModal.propTypes = {
  dataInitial: PropTypes.object,
  onModalClose: PropTypes.func.isRequired,
  onAdded: PropTypes.func.isRequired,
};

export default withTranslation('vehicle_add_modal')(VehicleAddModal);
